const Item = ({ text }) => (
  <span className="flex items-center gap-8 pr-8 shrink-0">
    <span className="font-serif italic text-lg sm:text-xl text-cream/70 whitespace-nowrap">{text}</span>
    <span className="w-1.5 h-1.5 rotate-45 bg-gold/60 shrink-0" />
  </span>
);

export const Marquee = ({ items }) => (
  <div data-testid="editorial-marquee" className="border-y border-gold/15 py-5 overflow-hidden bg-gallery/60">
    <div className="flex animate-marquee w-max">
      {[...items, ...items].map((t, i) => (
        <Item key={i} text={t} />
      ))}
    </div>
  </div>
);
